//Defaults
window.addEventListener("load", function () {
  setGalleryHeight();
  pin();
  pinBtn();
  document.querySelector('.gallery-swiper').classList.add('show');
  document.querySelector('.bottom-logo').classList.add('show');
});

window.addEventListener("resize", function(){
  setGalleryHeight();
  zoomWidth();
  pin();
  pinBtn();
  //setBtnWidth();
});


window.onscroll = function() {
  pin();
};

//Set True Height
let setGalleryHeight = function(){
  let trueHeight = window.innerHeight - 164;
  let setHeights = document.querySelectorAll('.gallery-swiper');
  setHeights.forEach(function(item,i){
    item.style.height = trueHeight + "px";
  });
}

//Mobile Swiper
var swiperMobile = new Swiper(".mobile-swiperx", {
  loop: true,
  autoHeight: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

//Gallery Swiper
var swiperGallery = new Swiper(".gallery-swiper", {
  slidesPerView: "auto",
  loop: true,
  freeMode: true,
  mouseWheel: {
    releaseOnEdges: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

let galleryBtn = document.querySelectorAll('.gallery-btn');
galleryBtn.forEach(function(item,i){
  item.addEventListener('click', function(event){
    event.preventDefault();
    let galleryIndex = i;
    //swiperZoom.slideTo(galleryIndex);
    document.querySelector('body').classList.add('gallery-active');

    swiperZoom.slideTo(galleryIndex);
    document.querySelector('.zoom-swiper').classList.add('fully-loaded');

  });
});

//Zoom Gallery
var swiperZoom = new Swiper(".zoom-swiper", {
  loop: true,
  slidesPerView: "1",
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});


let zoomWidth = function(){
  let zoomCon = document.querySelectorAll('.zoom-swiper .swiper-slide')[0].querySelector('img');
  document.querySelector('.zoom-swiper .swiper-pagination').style.width = (zoomCon.width - 24) + "px";

  let zoomWidth = document.querySelector('.zoom-swiper').offsetWidth;

  let zoomSides = (zoomWidth - zoomCon.width) / 2;

  let nextBtn = document.querySelector('.zoom-swiper .swiper-button-next');
  let prevBtn = document.querySelector('.zoom-swiper .swiper-button-prev');

  nextBtn.style.width = zoomSides + "px";
  prevBtn.style.width = zoomSides + "px";
}

zoomWidth();

let zoomBtn = document.querySelectorAll('.zoom-btn');
zoomBtn.forEach(function(item,i){
  item.addEventListener('click', function(event){
    event.preventDefault();
    document.querySelector('body').classList.toggle('zoom');
  });
});

//Close Zoom Gallery
let closeZoom = document.querySelector('.close-gallery-btn');
closeZoom.addEventListener('click', function(event){
  event.preventDefault();
  document.querySelector('body').classList.remove('gallery-active');
  document.querySelector('body').classList.remove('zoom');
});

//Pin
let pin = function() {
  if (window.pageYOffset >= window.innerHeight - 164) {
    document.querySelector(".product-pg").classList.add("pin");
  } else {
    document.querySelector(".product-pg").classList.remove("pin");
  }
  //console.log(window.scrollY);
}

//Pin Button
let pinBtn = function(){
  let scrollPos = window.innerHeight - 164;
  document.querySelector('.pin-btn').addEventListener('click', function(event){
    event.preventDefault();
    window.scrollTo(window.scrollX, scrollPos);
  });
}

//Details
let details = document.querySelector('.description ul');

if(details){
  let cloneDetails = details.cloneNode(true);
  document.querySelector('.details').appendChild(cloneDetails);
}

//Related Products
let swiperTwo = new Swiper('.mobile-swiper', {
  pagination: {
    el: '.swiper-pagination',
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }
});

//Size Selector
// Select all drop selectors
let dropSelector = document.querySelectorAll('.select-size .selector a');

// Add click event listeners to each drop selector
dropSelector.forEach(function(item, i) {
  item.addEventListener('click', function(event) {
    event.preventDefault();
    
    let variantId = item.dataset.variantId;
    let variantInventory = item.dataset.inventory;
    let variantName = item.dataset.variantTitle;
    
    // Debugging index
    //console.log('Drop selector index:', i);
    
    // Update bubble selector
    let bubbleSelector = document.querySelector('.variant-radio');
    if (bubbleSelector) {
      bubbleSelector.checked = true;
    }
    
    // Update the first select-size-btn
    let selectSizeBtn1 = document.querySelector('.select-size-btn');
    if (selectSizeBtn1) {
      selectSizeBtn1.innerText = variantName;
    }
    
    // Update the first select-size
    let selectSize1 = document.querySelector('.select-size');
    if (selectSize1) {
      selectSize1.classList.remove('active');
    }
    
    // Update the second select-size-btn
    let selectSizeBtn2 = document.querySelectorAll('.select-size-btn')[1];
    if (selectSizeBtn2) {
      selectSizeBtn2.innerText = variantName;
    }
    
    // Update the second select-size
    let selectSize2 = document.querySelectorAll('.select-size')[1];
    if (selectSize2) {
      selectSize2.classList.remove('active');
    }
    
    // Set ATC button
    setAtcBtn(variantId, variantInventory, variantName);
  });
});

// Bubble selector code
let bubbleSelector = document.querySelectorAll('.variant-radio');

// Add click event listeners to each bubble selector
bubbleSelector.forEach(function(item, i) {
  item.addEventListener('click', function() {
    let variantId = item.value;
    let variantInventory = item.dataset.inventory;
    let variantName = item.dataset.variantTitle;
    let appendText = "";

    if (variantInventory == 1) {
      appendText = " - Last One";
    }
    
    // Update the first select-size-btn
    let selectSizeBtn = document.querySelector('.select-size-btn');
    if (selectSizeBtn) {
      selectSizeBtn.innerText = variantName + appendText;
    }

    // Update the first select-size
    let selectSize = document.querySelector('.select-size');
    if (selectSize) {
      selectSize.classList.remove('active');
    }

    // Set ATC button
    setAtcBtn(variantId, variantInventory, variantName);
  });
});


let setAtcBtn = function(variantId, variantInventory, variantName){
  let atcBtn = document.querySelectorAll('.atc-btn');

  if(variantInventory > 0){
    atcBtn.forEach(function(item,i){
      item.dataset.optionName = variantName;
      item.dataset.btnType = "add-to-cart";
      item.dataset.variantId = variantId;
      item.dataset.inventory = variantInventory;
      item.classList.add('enabled');
      item.innerText = "Add to Bag";
    });
  } else {
    atcBtn.forEach(function(item,i){
      item.dataset.optionName = variantName;
      item.dataset.btnType = "notify";
      item.dataset.variantId = variantId;
      item.dataset.inventory = variantInventory;
      item.classList.add('enabled');
      item.innerText = "Notify me when available";
    });
  }
}

//Add To Cart Button
let atcBtn = document.querySelectorAll('.atc-btn');
atcBtn.forEach(function(item,i){
  item.addEventListener('click', function(event){
    event.preventDefault();
    let buttonType = item.dataset.btnType;

    if(buttonType == "add-to-cart"){
      if(item.dataset.variantId != ""){
        let variantId = item.dataset.variantId;
        let variantInt = parseInt(variantId);
        let quantity = item.dataset.quantity;
        //let quantityInt = parseInt(quantity);
        let quantityInt = 1;
        let data = {
          "id": variantInt,
          "quantity": quantityInt,
          // "properties": {
          //   "inventory": item.dataset.inventory
          // }
        };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        })
        .then(response => response.json())
        .then(data => {
          //console.log('Success:', data);
          document.querySelector('body').classList.add('blur');
          fetchCart();
          document.querySelector('#side-cart').classList.add('active');
          //window.location.href = "/cart";
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      } else {
        //item.innerText = "Make a Selection";
        console.log("Make a Selection");
      }
    } else if(buttonType == "notify"){
      //console.log("Notify");
      document.querySelector("#notify-email-error").classList.remove("show");
      document.querySelector("#notify-size-error").classList.remove("show");
      let variantId = item.dataset.variantId;
      let variantName = item.dataset.optionName;
      setNotify(variantName, variantId);
      sideNotify.classList.add('active');
      sideNotify.classList.add('automatic');
      blurCon.classList.add('blur');
    } else {
      console.log("Make a Selection");
    }

  });
});

//Dropdowns
let dropBlock = document.querySelectorAll('.drop-block');

dropBlock.forEach(function(item,i){
  let dropBtn = item.querySelector('.drop-btn');

  if(dropBtn.classList.contains('single') == true){
    dropBtn.addEventListener('click', function(event){
      event.preventDefault();
    });
  } else {
    dropBtn.addEventListener('click', function(event){
      event.preventDefault();
      if(i == 0){
        dropBlock[1].classList.remove('active');
      } else {
        dropBlock[0].classList.remove('active');
      }
      item.classList.toggle('active');
    });
  }
});

//Notify x Back in Stock
let setNotify = function(variantName, variantId){
  document.querySelector('#notify-size').innerText = variantName;
  document.querySelector('#notify-size-input').value = variantName;
  document.querySelector('#submit-notify-btn').dataset.variantId = variantId;
  document.querySelector('#submit-notify-btn').dataset.optionName = variantName;
};

//Size Guide
let sizeGuideBtn = document.querySelectorAll('.size-guide-btn');
let closeSizeGuide = document.querySelectorAll('.close-size-guide-btn');

if(sizeGuideBtn.length > 0){ 
  sizeGuideBtn.forEach(function(item,i){
    item.addEventListener('click', function(event){
      event.preventDefault();
      blurCon.classList.add('blur');
      document.querySelector('#size-guide').classList.add('active');
    });
  });

  let inchBtn = document.querySelector('#inch-btn');
  let centBtn = document.querySelector('#cent-btn');

  centBtn.addEventListener('click', function(event){
    event.preventDefault();
    inchBtn.classList.remove('active');
    centBtn.classList.add('active');
    convertToCentimeters();
  });

  let convertToCentimeters = function(){
    // Get all tables within the specified selector
    let tables = document.querySelectorAll('table');

    tables.forEach(table => {
      // Get all cells within each table
      let cells = table.querySelectorAll('td');

      cells.forEach(cell => {
        // Extract the content of each cell
        let content = cell.textContent.trim();

        // Check if the content contains an inch value
        if(content.includes('"')) {
          // Extract the numerical part and convert it to centimeters
          let inches = parseFloat(content.replace('"', ''));
          let centimeters = (inches * 2.54).toFixed(2) + ' cm';

          // Replace the cell content with the centimeter value
          cell.textContent = centimeters;
        }
      });
    });
  };

  let convertToInches = function(){
    // Get all tables within the specified selector
      let tables = document.querySelectorAll('table');

    tables.forEach(table => {
      // Get all cells within each table
      let cells = table.querySelectorAll('td');

      cells.forEach(cell => {
        // Extract the content of each cell
        let content = cell.textContent.trim();

        // Check if the content contains a centimeter value
        if(content.includes(' cm')) {
          // Extract the numerical part and convert it to inches
          let centimeters = parseFloat(content.replace(' cm', ''));
          let inches = (centimeters / 2.54).toFixed(2);

          // Remove .00 if present
          if(inches.endsWith('.00')) {
            inches = parseInt(inches).toString();
          }

          // Append the inch symbol
          inches += '"';

          // Replace the cell content with the inch value
          cell.textContent = inches;
        }
      });
    });
  };

  // Call the function to perform the conversion
  convertToInches();

  inchBtn.addEventListener('click', function(event){
    event.preventDefault();
    centBtn.classList.remove('active');
    inchBtn.classList.add('active');
    convertToInches();
  });

}

closeSizeGuide.forEach(function(item,i){
  item.addEventListener('click', function(event){
    event.preventDefault();
    blurCon.classList.remove('blur');
    document.querySelector('#size-guide').classList.remove('active');
  });
});

//Back in Stock
let sideNotify = document.querySelector('#side-notify');
let notifyCheckbox = sideNotify.querySelector('.checkbox a');
let submitNotifyBtn = document.querySelector('#submit-notify-btn');
let notifySizeError = document.querySelector('#notify-size-error');
let notifyEmailError = document.querySelector('#notify-email-error');
let closeNotifyBtn = document.querySelectorAll('.close-notify-btn');

notifyCheckbox.addEventListener('click', function(event){
  event.preventDefault();
  notifyCheckbox.classList.toggle('active');
});

submitNotifyBtn.addEventListener('click', function(event){
  event.preventDefault();
  let emailCheck = document.querySelector('#notify-email');
  let sizeCheck = document.querySelector('#notify-size-input');

  console.log(emailCheck + " + " + sizeCheck);

  var isSizeEmpty = sizeCheck.value.trim() === '';
  var isEmailEmpty = emailCheck.value.trim() === '';
  var errors = [];

  if (isSizeEmpty) {
    errors.push('Text input is empty');
    notifySizeError.classList.add('show');
    if(isEmailEmpty == false){
      notifyEmailError.classList.remove('show');
    }
  }

  if (isEmailEmpty) {
    errors.push('Email input is empty');
    notifyEmailError.classList.add('show');
    if(isSizeEmpty == false){
      notifySizeError.classList.remove('show');
    }
  }

  if (errors.length > 0) {
    console.log('Errors:', errors.join('; '));
  } else {
    notifySizeError.classList.remove('show');
    notifyEmailError.classList.remove('show');
    console.log('No errors, inputs are valid');
    submitNotificationForm();
  }
});

closeNotifyBtn.forEach(function(item,i){
  item.addEventListener('click', function(event){
    event.preventDefault();
    sideNotify.classList.remove('manual');
    sideNotify.classList.remove('automatic');
    sideNotify.classList.remove('active');
    blurCon.classList.remove('blur');
  });
});

let submitNotificationForm = function(){
  let notifyEmail = document.querySelector("#notify-email").value;
  let notifySize = document.querySelector("#notify-size-input").value;
  let currentProducID = submitNotifyBtn.dataset.productId;
  let currentVariantID = submitNotifyBtn.dataset.variantId;
  let outgoingList = "X635Xx"; //Back in stock list

  if (notifyEmail != "" && notifySize != "") {
    fetch("https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", {
      method: "POST",
    })
    .then(function (response) {
      if (response.ok) {
        return response.json();
      }
        return Promise.reject(response);
      })
      .then(function (data) {
        console.log(data);
      })
      .catch(function (error) {
        console.warn("Something went wrong.", error);
      });
      $.ajax({
        type: "POST",
        url: "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe",
        data: {
          a: "Xuf2bf",
          email: notifyEmail,
          variant: currentVariantID,
          product: currentProducID, // Product must be present in Klaviyo catalog to record event.
          platform: "shopify",
          subscribe_for_newsletter: true, // Optional with "g". Defaults to false if omitted.
          g: outgoingList, // Optional with "subscribe_for_newsletter".
        },
        success: function (response) {
          console.log(response);
          // document.querySelector("#notify-email-error").classList.remove("show");
          // document.querySelector("#notify-size-error").classList.remove("show");
          document.querySelector("#notify-success").classList.add("show");
        },
      });
  } else {
    console.log("Error in submitNotificationForm");
  }
}

let notifyBtn = document.querySelectorAll('.notify-btn');

notifyBtn.forEach(function(item,i){
  item.addEventListener('click', function(event){
    event.preventDefault();
    sideNotify.classList.add('active');
    blurCon.classList.add('blur');
    sideNotify.classList.add('manual');
    //console.log(sizeDisplay)
  });
});

//First Color
let colorCon = document.querySelector('.select-color .selector');
let colorItems = [];
if(colorCon){
  colorItems = Array.from(colorCon.children);
}

//console.log(colorItems);

if(colorItems.length > 0){
  colorItems.sort((a, b) => {
    return window.getComputedStyle(a).order - window.getComputedStyle(b).order;
  });

  colorItems[0].classList.add('first-color');
  colorItems[colorItems.length - 1].classList.add('last-color');
}


//Mobile ATC Sticky
let mobileATC = document.querySelector('#mobile-atc');

if (mobileATC) {
  // Ensure GSAP and ScrollTrigger are loaded
  gsap.registerPlugin(ScrollTrigger);

  // Create the ScrollTrigger instance
  let createScrollTrigger = () => {
    ScrollTrigger.create({
      trigger: ".mat-desc",
      start: "bottom+=128px bottom",
      end: "bottom-=128px bottom",
      //markers: true,
      onEnter: () => mobileATC.classList.add("sticky"),
      onLeaveBack: () => mobileATC.classList.remove("sticky")
    });

    // Refresh ScrollTrigger after the page has fully loaded
    ScrollTrigger.refresh();
  };

  // Check if the document is ready
  if (document.readyState === "complete") {
    createScrollTrigger();
  } else {
    window.addEventListener("load", createScrollTrigger);
  }
}

//Scroll Show Mobile ATC
document.addEventListener("DOMContentLoaded", function() {
  gsap.registerPlugin(ScrollTrigger);

  ScrollTrigger.create({
    trigger: "#info-pin",
    start: "top bottom-=128px",
    onEnter: () => document.getElementById('mobile-atc').classList.add('orange'),
    onLeaveBack: () => document.getElementById('mobile-atc').classList.remove('orange'),
  });


});
